(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* <news-gallery>: click right half = next, left half = previous,
       swipe on touch, arrow keys, instant swap, loops, preloads neighbours. */
    class NewsGallery extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.counter = this.querySelector('[data-counter]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.hasAttribute('data-active')));
        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', (event) => {
          if (this.consumeSwipe(event)) return;
          this.go(this.index - 1);
        });
        this.querySelector('[data-next]')?.addEventListener('click', (event) => {
          if (this.consumeSwipe(event)) return;
          this.go(this.index + 1);
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index - 1);
          }
        });

        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') return;
          this.start = { x: event.clientX, y: event.clientY };
        }, { passive: true });

        this.addEventListener('pointerup', (event) => {
          if (!this.start || event.pointerType !== 'touch') return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.swiped = true;
            this.go(this.index + (dx < 0 ? 1 : -1));
            setTimeout(() => (this.swiped = false), 350);
          }
        }, { passive: true });

        this.addEventListener('pointercancel', () => (this.start = null), { passive: true });

        this.update();
      }

      go(target) {
        const count = this.slides.length;
        this.index = ((target % count) + count) % count;
        this.update();
      }

      update() {
        const count = this.slides.length;
        const near = new Set([
          (this.index + 1) % count,
          (this.index + 2) % count,
          (this.index - 1 + count) % count,
        ]);

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.toggleAttribute('data-active', active);
          slide.toggleAttribute('data-near', !active && near.has(i));
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('news-video').forEach((video) => video.sync && video.sync());
        });

        if (this.counter) this.counter.textContent = String(this.index + 1);
      }

      /* A swipe also fires a click on the zone under the finger: ignore it. */
      consumeSwipe(event) {
        if (!this.swiped) return false;
        event.preventDefault();
        this.swiped = false;
        return true;
      }
    }

    /* <news-video>: muted loop that only plays while visible
       (and only on the active gallery slide), with a sound toggle. */
    class NewsVideo extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.video = this.querySelector('video');
        this.soundButton = this.querySelector('[data-sound]');
        if (!this.video) return;

        this.video.muted = true;
        this.video.playsInline = true;
        this.inView = false;

        if (reducedMotion.matches) {
          this.video.controls = true;
          if (this.soundButton) this.soundButton.remove();
          return;
        }

        this.soundButton?.addEventListener('click', () => {
          this.video.muted = !this.video.muted;
          this.soundButton.textContent = this.video.muted ? 'Sound off' : 'Sound on';
          this.soundButton.setAttribute('aria-pressed', String(!this.video.muted));
        });

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.inView = entry.isIntersecting;
            this.sync();
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      sync() {
        if (!this.video || reducedMotion.matches) return;
        const slide = this.closest('[data-slide]');
        const onActiveSlide = !slide || slide.hasAttribute('data-active');

        if (this.inView && onActiveSlide) {
          if (this.video.preload === 'none') this.video.preload = 'auto';
          this.video.play().catch(() => {});
        } else if (!this.video.paused) {
          this.video.pause();
        }
      }
    }

    if (!customElements.get('news-gallery')) customElements.define('news-gallery', NewsGallery);
    if (!customElements.get('news-video')) customElements.define('news-video', NewsVideo);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.rating-wrapper').forEach(function(el) {
    el.style.cursor = 'pointer';
    el.addEventListener('click', function() {
      window.location.href = '/pages/community';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
